import { useMemo, useState } from "react";
import "./transaction.css";
import CardCustom from "../../components/card";
import { TableCustomProps } from "../../components/table/table";
import { LottiesComponent } from "../../components/loadingLotties/LottiesComponent";
import cardLottie from "../../assets/lottie/target.json";
import TableMaterial from "../../components/tableMaterial/tableMaterial";
import ModalUI from "../../components/modalUI/ModalUI";
import { TransactionModal } from "./transactionModal/TransactionModal";
import ButtonUI from "../../components/button/buttons";
import { PaymentIcon } from "react-svg-credit-card-payment-icons";
import HelpIcon from "@mui/icons-material/Help";
import useFetchTransactionsByUser from "../../service/userTransactions/getTransaction";
import { setDatasets } from "react-chartjs-2/dist/utils";
import { formatToMexicanPesos } from "../../components/utils/format";
import StatusLabel from "../../components/utils/StatusLabel";
import { getOpenpayErrorMessage } from "../../const/errorCodeOpen.const";

const Transaction = () => {
  const storedToken = sessionStorage.getItem("userData");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [selectedTransaction, setSelectTransaction] = useState<null>(null);

  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [status, setStatus] = useState("ALL");

  const handleOpenModal = (transaction: any) => {
    setOpenModal(true);
    setSelectTransaction(transaction);
    // setOpenModal(true);
  };

  const transformDataToTable = (
    transactions: any[]
  ): TableCustomProps["rows"] => {

    return transactions.map((transaction) => ({

      name: transaction.full_name,
      company: (
        <PaymentIcon
          type={transaction.card_brand}
          format="flatRounded"
          width={36}
        />
      ),
     // cardNumber: transaction?.cardNumber,
      activity:  getOpenpayErrorMessage(transaction.status_description) ?? transaction.status_description ,
      email: transaction.email,
      amount: formatToMexicanPesos(transaction.amount) ,
      comision: transaction?.comission ?  formatToMexicanPesos(transaction?.comission?.api_commission?.commission ): formatToMexicanPesos(transaction?.amount_with_comision),
      cardNumber: transaction.cardNumber,
      date: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      }),
      status: (<StatusLabel value={transaction.status} />),

      info: (
        <div>
          <ButtonUI
            icon={<HelpIcon />}
            variant="text"
            onClick={() => handleOpenModal(transaction)}
          />
        </div>
      ),
    }));
  };

  const { transactions, loading, error } = useFetchTransactionsByUser(
    page,
    rowsPerPage,
    {
      email: email || undefined,
      status: status || undefined,
      dateFrom: startDate ? startDate.toISOString() : undefined,
      dateTo: endStarDate ? endStarDate.toISOString() : undefined,
    }
  );

  const dataTable: any = {
    columns: [
      { id: "name", label: "Nombre" },
      { id: "company", label: "Banco" },
      { id: 'cardNumber', label: 'Tarjeta'},
      { id: "activity", label: "Respuesta de banco" },
      { id: "email", label: "Correo" },
      { id: "amount", label: "Pago" },
      { id: "comision", label: "Comision" },
      //{ id: "country", label: "Moneda" },
      { id: "date", label: "Fecha" },
      { id: "status", label: "Estado" },
      { id: "info", label: "Info" },
    ],
    rows: transformDataToTable(  transactions?.response?.data || []),
  };


  const onChangeEmail = (e: any) => {
    // setEmail(e.target.value);
  };

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
  };

  const onClickCleanFilters = () => {
    setEndStartDate(null);
    setStartDate(null);
    setStatus("ALL");
  };

 
  return (
    <div>
        <CardCustom classCustom="activity_card">
          <h2>Transacciones</h2>
          <TableMaterial
          isClean={true}
          id="table-reportes"
            setStatus={setStatus}
            status={status}
            onClickFilters={onClickCleanFilters}
            valueInput={email}
            onClickSearch={handleSearchClick}
            onChangeInput={onChangeEmail}
            isDate={true}
            setEndDate={setEndStartDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endStarDate}
            totalRows={transactions?.response?.pagination?.countData}
            setPage={setPage}
            page={page}
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            report={true}
            columns={dataTable.columns}
            rows={dataTable?.rows || []}
            loading={loading}
            isSearch={false}
          />
        </CardCustom>
      <ModalUI
        children={<TransactionModal data={selectedTransaction || []} />}
        title="Información de transacción"
        open={openModal}
        setOpen={setOpenModal}
      />
    </div>
  );
};

export default Transaction;
